<template>
  <div class="ExpenseBillPrint" id="ExpenseBillPrint">
    <div v-for="(item, index) in feeData" :key="index" style="page-break-after: always;">
        <div class="title">
            <p>{{getDate('y', item.sfqj)}}年{{getDate('M', item.sfqj)}}月份缴费清单</p>
            <p class="subtitle">Shanghai Oricent Center Tenant Invoice</p>
        </div>
        <div class="print-main">
            <table class="pring-table-header" cellpadding="0" cellspacing="0">
                <colgroup>
                    <col width="18.75%">
                    <col width="18.75%">
                    <col width="20.5%">
                    <col width="18.75%">
                    <col width="18.75%">
                </colgroup>
                <thead>
                    <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td colspan="2">
                            <span>日期（Date）：{{item.son[0].create_date}}</span>
                        </td>
                    </tr>
                </thead>
            </table>
            <table class="pring-table-middle" cellpadding="0" cellspacing="0">
                <colgroup>
                    <col width="18.75%">
                    <col width="18.75%">
                    <col width="20.5%">
                    <col width="18.75%">
                    <col width="18.75%">
                </colgroup>
                <thead>
                    <tr>
                        <td>
                            <span>单元（Unit）：</span>
                        </td>
                        <td colspan="2">
                            <!-- {{item.son[0].floor}} -->
                            {{item.son[0].room}}
                        </td>
                        <td>
                            <span>面积（Area）：</span>
                        </td>
                        <td>
                            <span>{{Number(item.son[0].num).toFixed(2)}}m²</span>
                        </td>
                    </tr>
                </thead>
            </table>
            <table class="pring-table-main" cellpadding="0" cellspacing="0">
                <colgroup>
                    <col width="18.75%">
                    <col width="18.75%">
                    <col width="20.5%">
                    <col width="18.75%">
                    <col width="18.75%">
                </colgroup>
                <thead>
                    <tr>
                        <td colspan="5">
                            <span>{{item.company_name}}</span>
                        </td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="items in item.son" :key="items.id">
                        <td>
                            <span>{{items.type}}：</span>
                        </td>
                        <td>
                            <!-- <span>{{items.room}}</span> -->
                            <span>{{items.qijian}}</span>
                        </td>
                        <td colspan="2">
                            <!-- {{items.qijian}} -->
                            人民币
                        </td>
                        <td>
                            <span>{{Number(items.total).toFixed(2)}}</span>
                        </td>
                    </tr>
                    <!-- <tr>
                        <td>
                            <span>物业费：</span>
                        </td>
                        <td>
                            <span>1101-1103</span>
                        </td>
                        <td colspan="2">
                            7.1-7.31
                        </td>
                        <td>
                            <span>6666</span>
                        </td>
                    </tr> -->
                    <tr>
                        <td>
                            <span>小计(Total)：</span>
                        </td>
                        <td colspan="3">
                            <span>本月支付人民币</span>
                        </td>
                        <td>
                            <span>{{total(item)}}</span>
                        </td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td rowspan="3">
                            账户信息：
                        </td>
                        <td>户名：</td>
                        <td colspan="3">{{item.son[0].bank_name}}</td>
                    </tr>
                    <tr>
                        <td>开户行：</td>
                        <td colspan="3">{{item.son[0].shou_bank}}</td>
                    </tr>
                    <tr>
                        <td>账号：</td>
                        <td colspan="3">{{item.son[0].bank_no}}</td>
                    </tr>
                    <tr>
                        <td colspan="5" style="font-size: 12px; white-space: pre;">提示：根据合同，此缴费清单上的费用请务必在{{getDate('y年m月d日', item.son[0].jiezhi)}}之前缴清！若逾期不付，将产生违约金。
    本通知书仅提示贵司及时全面地履行相关合同义务,并不构成对贵我双方之租赁合同的任何变更及补充,且我司不因此放弃任何法律之权利。</td>
                    </tr>
                </tfoot>
            </table>
            <table class="pring-table-footer" cellpadding="0" cellspacing="0">
                <colgroup>
                    <col width="18.75%">
                    <col width="18.75%">
                    <col width="20.5%">
                    <col width="18.75%">
                    <col width="18.75%">
                </colgroup>
                <thead>
                    <tr>
                        <td colspan="5">
                            若有异议，请拨打客服电话：61273500，财务电话：52282515
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <span>制表：张莹</span>
                        </td>
                        <td></td>
                        <td>
                            <span>复核：袁颖</span>
                        </td>
                        <td></td>
                    </tr>
                </thead>
            </table>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    name: "ExpenseBillPrint",
    data() {
        return {
            iYear: "2023",
            iMonth: "07",
            date: "2023-06-12",
            Area: "5555555",
            Unit: "111112222",
            feeData: []
        };
    },
    methods: {
        total(data) {
            let sum = 0;
            data.son.forEach(item => {
                sum += Number(item.total);
            });
            return sum.toFixed(2);
        },
        getDate(type, data) {
            if (data !== null && data !== "") {
                let date = new Date(data);
                if (type === "y") {
                    return date.getFullYear();
                } else if (type === "M") {
                    return date.getMonth() + 1 >= 10
                        ? date.getMonth() + 1
                        : "0" + (date.getMonth() + 1);
                } else if (type === "y年m月d日") {
                    return `${date.getFullYear()}年${
                        date.getMonth() + 1 >= 10
                            ? date.getMonth() + 1
                            : "0" + (date.getMonth() + 1)
                    }月${
                        date.getDate() >= 10
                            ? date.getDate()
                            : "0" + date.getDate()
                    }日`;
                }
            } else {
                return "";
            }
        },
        bankShow(index, data) {
            let str = this.ReplaceChina(data);
            if (str !== null) {
                return str.split(",")[index];
            } else {
                return "";
            }
        },
        ReplaceChina(obj) {
            // obj需要转换的值
            let oldValue = obj;
            if (oldValue === null) {
                oldValue = "";
            }
            let str = "";
            if (oldValue.indexOf("，") != -1) {
                // 寻找每一个中文逗号，并替换
                str = oldValue.replace(/，/gi, ",");
            }
            return str;
        },
        SetfeeData(data) {
            let that = this;
            return new Promise(resolve => {
                // console.log(data);
                that.feeData = data;
                resolve();
            });
        }
    }
};
</script>

<style>
#ExpenseBillPrint {
    color: #000;
}
#ExpenseBillPrint .title {
    font-size: 20px;
    text-align: center;
    letter-spacing: 1px;
    /* font-family: 宋体; */
    line-height: 30px;
    font-weight: bolder;
    color: #000;
}
#ExpenseBillPrint .title .subtitle {
    font-size: 16px;
    letter-spacing: normal;
    font-family: "Times New Roman";
}
#ExpenseBillPrint table {
    width: 100%;
    table-layout: fixed;
    font-size: 14px;
}
#ExpenseBillPrint .pring-table-middle {
    border-top: 1px #000000 solid;
    border-left: 1px #000000 solid;
}
#ExpenseBillPrint .pring-table-middle tr td {
    border-right: 1px #000000 solid;
    border-bottom: 1px #000000 solid;
}
/* #ExpenseBillPrint table tr td:nth-child(3) {
    width: 25%;
} */
#ExpenseBillPrint table tr td {
    height: 25px;
    line-height: 25px;
    padding: 0 5px;
    color: #000;
}
#ExpenseBillPrint .pring-table-middle tr td:nth-child(2),
#ExpenseBillPrint .pring-table-middle tr td:nth-child(4) {
    text-align: center;
}
#ExpenseBillPrint .pring-table-main {
    border-left: 1px #000000 solid;
}
#ExpenseBillPrint .pring-table-main tr td {
    border-right: 1px #000000 solid;
    border-bottom: 1px #000000 solid;
}
#ExpenseBillPrint .pring-table-main tbody tr td:nth-child(2),
#ExpenseBillPrint .pring-table-main tbody tr td:nth-child(3) {
    text-align: center;
}
#ExpenseBillPrint .pring-table-main tbody tr td:last-child {
    text-align: right;
}
#ExpenseBillPrint .pring-table-main thead tr td {
    text-align: center;
}
@media print {
    #ExpenseBillPrint {
        color: #000;
    }
    #ExpenseBillPrint .title {
        font-size: 20px;
        text-align: center;
        letter-spacing: 1px;
        /* font-family: 宋体; */
        line-height: 30px;
        font-weight: bolder;
    }
    #ExpenseBillPrint .title .subtitle {
        font-size: 16px;
        letter-spacing: normal;
        font-family: "Times New Roman";
    }
    #ExpenseBillPrint table {
        width: 100%;
        table-layout: fixed;
        font-size: 14px;
    }
    #ExpenseBillPrint .pring-table-middle {
        border-top: 1px #000000 solid;
        border-left: 1px #000000 solid;
    }
    #ExpenseBillPrint .pring-table-middle tr td {
        border-right: 1px #000000 solid;
        border-bottom: 1px #000000 solid;
    }
    /* #ExpenseBillPrint table tr td:nth-child(3) {
        width: 25%;
    } */
    #ExpenseBillPrint table tr td {
        height: 25px;
        line-height: 25px;
        padding: 0 5px;
    }
    #ExpenseBillPrint .pring-table-middle tr td:nth-child(2),
    #ExpenseBillPrint .pring-table-middle tr td:nth-child(4) {
        text-align: center;
    }
    #ExpenseBillPrint .pring-table-main {
        border-left: 1px #000000 solid;
    }
    #ExpenseBillPrint .pring-table-main tr td {
        border-right: 1px #000000 solid;
        border-bottom: 1px #000000 solid;
    }
    #ExpenseBillPrint .pring-table-main tbody tr td:nth-child(2),
    #ExpenseBillPrint .pring-table-main tbody tr td:nth-child(3) {
        text-align: center;
    }
    #ExpenseBillPrint .pring-table-main tbody tr td:last-child {
        text-align: right;
    }
    #ExpenseBillPrint .pring-table-main thead tr td {
        text-align: center;
    }
}
</style>
